import { mergeReportedSelection } from '@commons/utils/listViewSelection';

/**
 * Keep only the most relevant row of each supplier product, as a supplier product can be mapped to one ingredient only
 *
 * @param {Array<Object>} rows - The selected rows
 *
 * @returns {Array<Object>} The selected rows with distinct supplier products
 */
const keepMostRelevantRowPerSupplierProduct = (rows) =>
  Object.values(
    rows.reduce((result, row) => {
      const keptRow = result[row.supplierProductId];

      if (!keptRow || row.relevance > keptRow.relevance) {
        result[row.supplierProductId] = row;
      }

      return result;
    }, {}),
  );

/**
 * Build the selected rows from the ones reported by ListView, keeping the selected rows hidden by the search
 * and a single row per supplier product
 *
 * @param {Array<Object>} rows - All the rows of the modal, flagged with isRowSelected
 * @param {Array<Object>} reportedItems - The rows reported by ListView through setSelectedItems
 * @param {Array<string>} visibleIds - The ids of the rows matching the ListView search, on every page
 *
 * @returns {Array<Object>} The selected rows
 */
export const getSelectedRows = (rows, reportedItems, visibleIds) => {
  const currentSelectedIds = rows.filter(({ isRowSelected }) => isRowSelected).map(({ id }) => id);

  const selectedIds = new Set(
    mergeReportedSelection(reportedItems, visibleIds, currentSelectedIds),
  );

  return keepMostRelevantRowPerSupplierProduct(rows.filter(({ id }) => selectedIds.has(id)));
};
